<div class="login__body box box--shadow">

    <div class="reset__content" *ngIf="state === 'loading'">
        <msc-common-spinner></msc-common-spinner>
        <p>{{ 'subscription.activating' | translate }}</p>
    </div>

    <div class="reset__content" *ngIf="state === 'success'">
        <i class="icon icon-checkmark-1 bullet-success"></i>
        <h2>{{ 'subscription.activated-title' | translate }}</h2>
        <p>{{ 'subscription.activated-redirect' | translate }}</p>
    </div>

    <div class="reset__content" *ngIf="state === 'error'">
        <i class="icon icon-alert-triangle" style="font-size:2.5rem;color:#dc2626;"></i>
        <h2>{{ 'subscription.login-error-title' | translate }}</h2>
        <p>{{ 'subscription.login-error-body' | translate }}</p>
        <msc-button [routerLink]="['/login']" class="msc-button--primary" palette="primary">
            {{ 'words.login' | translate }}
        </msc-button>
    </div>

</div>
